<template>
  <container fluid>
    <div class="v-col_count">
      <v-row>
        <v-col md="6" lg="6" sm="12">
          <div class="text-left container">
            <h1 class="pb-3 pt-5">{{ name }}</h1>

            <p>
              {{ title }}
            </p>
          </div>
        </v-col>

        <v-col md="6" lg="6" sm="12" class=" ma-0 pa-0">
          <v-img :src="getImageTag" class="white--text img" />
        </v-col>
      </v-row>
    </div>
  </container>
</template>

<script>
export default {
  components: {},
  props: ["name", "subProps"],
  props: {
    name: String,
    title: {
      type: String,
      default:
        "Marine industry software designed to streamline operations and improve efficiency"
    }
  },

  data: () => ({
    imageURLs: [
      "https://img.freepik.com/free-photo/aerial-view-container-cargo-ship-sea_335224-735.jpg?w=740&t=st=1677569947~exp=1677570547~hmac=7ec00f1829f0fd0e49efc53868924b8c0fb8f390b007911b6aea50d48f961d3e",
      "https://www.trade.gov/sites/default/files/2021-01/Container%20Ship%20Overhead%20View%20%28resized%29.jpg",
      "https://img.freepik.com/free-photo/unknown-industrial-ship-mediterranean-sea_1401-373.jpg?w=740&t=st=1677569983~exp=1677570583~hmac=b43c2960c1b6530a0154588f236a1ff6a3a51a6444aa81317dcdb320be9ed1b6"
    ]
  }),
  computed: {
    getImageTag() {
      var img = "";
      var randomIndex = Math.floor(Math.random() * this.imageURLs.length);
      console.log(randomIndex);
      img += this.imageURLs[randomIndex];
      img += "";
      return img;
    }
  }
};
</script>

<style scoped>
.v-col_count {
  background-color: rgb(55, 110, 205);
  max-width: 100%;
  height: 300px;
}

.img {
  max-width: 100%;
  height: 300px;
}
p {
  font-size: 20px;
  color: white;
}
h1 {
  font-size: 30px;
  color: white;
}
</style>
